import PageHero from "@/components/base/PageHero";
import ScrollReveal from "@/components/base/ScrollReveal";
import SectionHeading from "@/components/base/SectionHeading";
import CompanySubNav from "@/pages/company/components/CompanySubNav";
import { OFFICERS } from "@/constants/site";

export default function CompanyOfficers() {
  return (
    <div className="w-full bg-background-50">
      <PageHero
        en="OFFICERS"
        ja="役員紹介"
        crumbs={[{ label: "企業情報", path: "/company" }, { label: "役員紹介" }]}
      />
      <CompanySubNav />

      <section className="w-full py-20 md:py-28">
        <div className="mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
          <ScrollReveal>
            <SectionHeading label="役員紹介" en="Officers" />
          </ScrollReveal>

          <div className="mt-14 grid grid-cols-1 gap-px border border-background-300/70 bg-background-300/70 md:grid-cols-2">
            {OFFICERS.map((officer, index) => (
              <ScrollReveal key={officer.name} delay={index * 120}>
                <article className="flex h-full flex-col bg-background-50 p-8 md:p-12">
                  <span className="font-label text-xs tracking-[0.3em] text-accent-600">
                    {officer.roleEn.toUpperCase()}
                  </span>
                  <div className="mt-8 flex items-baseline gap-4">
                    <span className="font-heading text-2xl tracking-[0.08em] text-foreground-950 md:text-3xl">
                      {officer.name}
                    </span>
                  </div>
                  <span className="mt-2 font-body text-[13px] tracking-[0.1em] text-foreground-500">
                    {officer.role}
                  </span>
                  <p className="mt-8 font-body text-[15px] leading-[2.1] text-foreground-700">
                    {officer.message}
                  </p>
                </article>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal delay={200}>
            <p className="mt-12 text-center font-body text-sm leading-[2] text-foreground-500">
              役員一同、ヒトの可能性を信じ、次の時代を創る挑戦を続けてまいります。
            </p>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
}